import { Component } from '@angular/core';

@Component({
    selector: 'app-preferences',
    imports: [],
    templateUrl: './preferences.component.html',
    styleUrl: './preferences.component.scss'
})
export class PreferencesComponent {

}
